import { dmnIdentity } from "../../utils/dmnIdentity";
import { getEnvironmentProps } from "../../utils/environment";
import { errorHandler, throwApiError } from "../errorHandler";

import { ConfigurableOption } from "../../types/VenueGroup";

export type PreOrderItem = {
  id: string;
  name: string;
  price: number;
  type: string;
  sub_type: string;
  description?: string;
  plu?: number;
  calories?: number;
  configurable_options?: ConfigurableOption[];
  allergens?: Record<string, boolean>;
  diet_types?: Record<string, boolean>;
};

export const fetchPreOrderItems = async (
  venueId: string | undefined
): Promise<PreOrderItem[]> => {
  if (!venueId) {
    return [];
  }

  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  try {
    const response = await fetch(
      `${environmentVars?.CORE_API_BASE_URL}/venues/${venueId}/preorder-items`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!response.ok) {
      await throwApiError(response, "Error fetching pre-order items");
    }

    const data = await response.json();
    const items = data?.payload?.venue?.booking_packages ?? data?.data ?? [];

    return items;
  } catch (error) {
    errorHandler(error, "Error fetching pre-order items");
    return [];
  }
};
